import React from 'react'
import { Modal, Button, Empty } from 'hljd'
import { inject, observer } from 'mobx-react'
import Chat from '@common/Chat'
import Style from './style.module.less'

export default inject('store')(
  observer(({ store: { liveLinkMicrophoneStore } }) => {
    const {
      linkSuccessUsers,
      showLinkSuccessUsersModal,
      linkSuccessUsersModalVisible
    } = liveLinkMicrophoneStore
    const length = linkSuccessUsers && linkSuccessUsers.length
    return (
      <Modal
        title={'连麦成功名单(' + length + ')'}
        visible={linkSuccessUsersModalVisible}
        onOk={showLinkSuccessUsersModal}
        wrapClassName={Style['link-success-users-modal']}
        onCancel={showLinkSuccessUsersModal}
        width={540}
        footer={
          <Button
            type="primary"
            onClick={showLinkSuccessUsersModal}
            style={{ letterSpacing: '-2px' }}
          >
            好的
          </Button>
        }
      >
        <div className={Style['link-success-users']}>
          {length ? (
            linkSuccessUsers.map((item, index) => (
              <div
                key={index}
                className={`${Style['users-item']} ${
                  (index + 1) % 2 ? '' : Style['users-item-margin']
                }`}
              >
                <span className={Style['users-item-nick']}>{item.nick}</span>
                <Chat
                  toUserId={item.userId || item.id}
                  children={<span>私信</span>}
                />
              </div>
            ))
          ) : (
            <Empty />
          )}
        </div>
      </Modal>
    )
  })
)
